import React from 'react';
import {
  type EmbeddedWhiteboardPlaceholderElement,
  type ComponentProps,
} from '@aha-app/aha-editor-v2';

interface EmbeddedWhiteboardPlaceholderComponentProps
  extends ComponentProps<EmbeddedWhiteboardPlaceholderElement> {
  children?: React.ReactNode;
}

const EmbeddedWhiteboardPlaceholderComponent: React.FC<
  EmbeddedWhiteboardPlaceholderComponentProps
> = ({ attributes, element, children }) => {
  return (
    <div contentEditable={false} {...attributes}>
      <aha-spinner size='18px' stroke='2px' />
      {children}
    </div>
  );
};

export default EmbeddedWhiteboardPlaceholderComponent;
